import Immutable from 'immutable';
import InterlibraryLoansConstants from '../../constants/InterlibraryLoansConstants';

const {
  FETCH_ILL_REQUEST,
  FETCH_ILL_SUCCESS,
  FETCH_ILL_FAILURE
} = InterlibraryLoansConstants;

const initialState = Immutable.Map();

export default function InterlibraryLoansReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ILL_SUCCESS:
    case FETCH_ILL_FAILURE: {
      return state.mergeDeep(action.payload.borrowing).set('isFetching', false);
    }

    case FETCH_ILL_REQUEST: {
      return state.set('isFetching', true);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/borrowing/InterlibraryLoansReducer.js